import React, { useState } from 'react';
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  FormHelperText,
  TextField,
} from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';

import LOGO_BPI from './img/bpi.svg';
import LOGO_BDO from './img/bdo.svg';
import LOGO_CB from './img/cb.svg';
import LOGO_MB from './img/mb.svg';
import LOGO_AUB from './img/aub.svg';
import LOGO_LBP from './img/lbp.svg';
import LOGO_RCBC from './img/rcbc.svg';
import LOGO_ML from './img/ml.svg';
import LOGO_PRU from './img/pru.svg';
import LOGO_SB from './img/sb.svg';
import LOGO_UB from './img/ub.svg';
import LOGO_DBP from './img/dbp.svg';
import LOGO_PNB from './img/pnb.svg';
import LOGO_MAY from './img/may.svg';
import LOGO_UCPB from './img/ucpb.svg';
import LOGO_AB from './img/ab.png';
import LOGO_EW from './img/ew.png';
import LOGO_PBC from './img/pbc.png';
import LOGO_AT from './img/at.jpg';
import LOGO_CTB from './img/ctb.jpg';

import Loader from 'react-loader-spinner';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';

import Card from './components/Card';

const UITF_PROVIDER = [
  {
    name: 'AB Capital',
    value: 'AB',
  },
  {
    name: 'Asia United Bank',
    value: 'AUB',
  },
  {
    name: 'ATRAM Trust Corporation',
    value: 'AT',
  },
  {
    name: 'BDO Unibank, Inc.',
    value: 'BDO',
  },
  {
    name: 'BPI Asset Management and Trust Corporation',
    value: 'BPI',
  },
  {
    name: 'China Banking Corporation',
    value: 'CB',
  },
  {
    name: 'CTBC Bank (Philippines) Corp.',
    value: 'CTB',
  },
  {
    name: 'EastWest Banking Corporation',
    value: 'EW',
  },
  {
    name: 'Development Bank of the Philippines',
    value: 'DBP',
  },
  {
    name: 'Land Bank of the Philippines',
    value: 'LBP',
  },
  {
    name: 'Manulife Asset Management and Trust Corporation (MAMTC)',
    value: 'ML',
  },
  {
    name: 'Maybank Philippines Inc.',
    value: 'MAY',
  },
  {
    name: 'Metropolitan Bank & Trust Co.',
    value: 'MB',
  },
  {
    name: 'Philippine Bank of Communications',
    value: 'PBC',
  },
  {
    name: 'Philippine National Bank',
    value: 'PNB',
  },
  // {
  //   name: 'Pru Life UK Investments',
  //   value: 'PRU',
  // },
  {
    name: 'Rizal Commercial Banking Corporation',
    value: 'RCBC',
  },
  {
    name: 'Security Bank Corporation',
    value: 'SB',
  },
  {
    name: 'United Coconut Planters Bank',
    value: 'UCPB',
  },
  {
    name: 'Union Bank',
    value: 'UB',
  },
];
const API = 'https://uitf.now.sh/api/uitf?name=';
const useStyles = makeStyles({
  app: {
    maxWidth: 1200,
    width: '100%',
    margin: '0 auto',
    fontFamily: 'Roboto',
  },

  header: {
    padding: 20,
    margin: '0 0 20px',
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    boxShadow: '0 3px 5px 2px rgba(33, 203, 243, .3)',
  },

  footer: {
    padding: 20,
    margin: '20px 0 0',
    background: 'linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)',
    boxShadow: '0 -3px 5px 2px rgba(33, 203, 243, .3)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#fff',
    '@media (max-width: 500px)': {
      display: 'block',
      textAlign: 'center',
    },

    '& a': {
      color: '#fff',
      textDecoration: 'none',
    },
  },

  svg: {
    width: 50,
    fill: '#fff',
    margin: '0 5px',
  },

  h1: {
    margin: 0,
    color: '#fff',
  },

  h2: {
    fontSize: 14,
    color: '#fff',
    fontWeight: 'normal',
  },

  select: {
    width: 320,
    marginTop: 20,
    '@media (max-width: 500px)': {
      width: '100%',
    },
  },

  filter: {
    width: 320,
    '@media (max-width: 500px)': {
      width: '100%',
    },
  },

  body: {
    position: 'relative',
    minHeight: 'calc(100vh - 251px)',
    padding: '0 20px',

    '@media (max-width: 500px)': {
      minHeight: 'calc(100vh - 302px)',
    },

    '& > p': {
      color: '#333',
    },
  },

  loading: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },

  card: {
    margin: '20px auto',
  },

  bankLogo: {
    margin: '20px 0',
    textAlign: 'left',
    '& img': {
      '@media (max-width: 500px)': {
        width: '100%',
        height: 60,
        objectFit: 'contain',
      },
    },
  },

  cardParent: {
    marginTop: 15,
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
  },
});

function App() {
  const classes = useStyles();
  const [uitf, setUitf] = useState([]);
  const [filteredUitf, setFilteredUitf] = useState([]);
  const [value, setValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = async (e) => {
    if (e.target.value.length === 0) return;
    setValue(e.target.value);
    setLoading(true);
    setFilteredUitf([]);
    setUitf([]);
    setErrorMsg('');
    try {
      const data = await fetch(`${API}${e.target.value}`);
      const uitf = await data.json();
      if (uitf.length == 0) {
        setErrorMsg('Sorry an error occured. Please contact @markanthonyuy');
      }
      setUitf(uitf);
      setLoading(false);
    } catch (e) {
      console.log(e);
      setLoading(false);
    }
  };

  const handleFilter = (e) => {
    if (e.target.value.length === 0) {
      setUitf(uitf);
      setFilteredUitf([]);
      return;
    }
    const data = uitf.filter((u) =>
      u.name.toLowerCase().includes(e.target.value.toLowerCase())
    );
    setFilteredUitf(data);
  };

  const displayResult = (data) => (
    <>
      <form noValidate autoComplete="off">
        <TextField
          className={classes.filter}
          id="filter-result"
          label="Filter Result"
          onChange={handleFilter}
        />
        <FormHelperText>Please input the name of the UITF</FormHelperText>
      </form>
      <div className={classes.cardParent}>
        {data.map((res, i) => (
          <Card uitf={res} key={i} />
        ))}
      </div>
    </>
  );

  return (
    <div className={classes.app}>
      <header className={classes.header}>
        <h1 className={classes.h1}>Philippine UITF Listing</h1>
        <h2 className={classes.h2}>as of Today {new Date().toDateString()}</h2>
      </header>
      <div className={classes.body}>
        <Alert severity="info" variant="outlined">
          A Unit Investment Trust Fund (UITF) is an open-ended pooled trust fund
          denominated in pesos or any acceptable currency, which is operated and
          administered by a trust entity and made available by participation.
        </Alert>
        <FormControl className={classes.select}>
          <InputLabel id="uitf">Select UITF</InputLabel>
          <Select
            labelId="uitf"
            defaultValue=""
            className={classes.select}
            onChange={handleChange}
            disabled={loading}
          >
            <MenuItem value="">
              <em>Select UITF</em>
            </MenuItem>
            {UITF_PROVIDER.map((_) => (
              <MenuItem value={_.value} key={_.value}>
                {_.name}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>Select UITF provider you wish to view</FormHelperText>
        </FormControl>
        <figure className={classes.bankLogo}>
          {value === 'BPI' && <img src={LOGO_BPI} width="150" alt="logo" />}
          {value === 'BDO' && <img src={LOGO_BDO} width="150" alt="logo" />}
          {value === 'MB' && <img src={LOGO_MB} width="150" alt="logo" />}
          {value === 'AUB' && <img src={LOGO_AUB} width="150" alt="logo" />}
          {value === 'LBP' && <img src={LOGO_LBP} width="150" alt="logo" />}
          {value === 'RCBC' && <img src={LOGO_RCBC} width="150" alt="logo" />}
          {value === 'ML' && <img src={LOGO_ML} width="150" alt="logo" />}
          {value === 'PRU' && <img src={LOGO_PRU} width="150" alt="logo" />}
          {value === 'UB' && <img src={LOGO_UB} width="150" alt="logo" />}
          {value === 'SB' && <img src={LOGO_SB} width="150" alt="logo" />}
          {value === 'CB' && <img src={LOGO_CB} width="150" alt="logo" />}
          {value === 'DBP' && <img src={LOGO_DBP} width="150" alt="logo" />}
          {value === 'PNB' && <img src={LOGO_PNB} width="150" alt="logo" />}
          {value === 'MAY' && <img src={LOGO_MAY} width="150" alt="logo" />}
          {value === 'UCPB' && <img src={LOGO_UCPB} width="150" alt="logo" />}
          {value === 'AB' && <img src={LOGO_AB} width="150" alt="logo" />}
          {value === 'EW' && <img src={LOGO_EW} width="150" alt="logo" />}
          {value === 'PBC' && <img src={LOGO_PBC} width="150" alt="logo" />}
          {value === 'AT' && <img src={LOGO_AT} width="150" alt="logo" />}
          {value === 'CTB' && <img src={LOGO_CTB} width="150" alt="logo" />}
        </figure>
        {loading && (
          <div className={classes.loading}>
            <Loader type="Grid" color="#2196F3" height={100} width={100} />
          </div>
        )}
        {filteredUitf.length
          ? displayResult(filteredUitf)
          : uitf.length
          ? displayResult(uitf)
          : errorMsg}
      </div>
      <footer className={classes.footer}>
        <p>
          <a href="https://markanthonyuy.com">Mark Anthony Uy</a> &copy; 2020
        </p>
        <div className={classes.social}>
          <a href="https://github.com/markanthonyuy" aria-label="Github Icon">
            <svg
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              className={classes.svg}
            >
              <title>GitHub icon</title>
              <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12" />
            </svg>
          </a>
          <a href="https://twitter.com/markanthonyuy" aria-label="Twitter Icon">
            <svg
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              className={classes.svg}
            >
              <title>Twitter icon</title>
              <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z" />
            </svg>
          </a>
          <a href="https://instagram.com/macmac.uy" aria-label="Instagram Icon">
            <svg
              role="img"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
              className={classes.svg}
            >
              <title>Instagram icon</title>
              <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
            </svg>
          </a>
        </div>
      </footer>
    </div>
  );
}

export default App;
